import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/app/[locale]/error.tsx");
